import React, {Component} from 'react';
import PropTypes from 'prop-types';

import * as QueryString from "query-string";
import * as UrlParse from "url-parse";

import Manifest from "./manifest/Manifest";
import Moire from "./moire/Moire.jsx";
import HomePage from "./homepage/HomePage.jsx";
import FractoApp from "./fracto-app/FractoApp";
import MidiPlay from "./midi/MidiPlay";
import Render3d from "./render3d/Render3d";
import Image from "./fracto/Image";
import Orbitals from "./fracto/Orbitals";
import Freq from "./freq-gen/Freq";

import ModulusEffectExtra from "./homepage/extras/ModulusEffectExtra.jsx";

const APP_MAIN_ROUTE = "/";
const APP_FRACTO_ROUTE = "/fracto-app";
const APP_MODULUS_EFFECT_ROUTE = "/the-modulus-effect";
const APP_STUDIO_WORKS_2006_ROUTE = "/studio-works-2006";
const APP_STUDIO_WORKS_2007_ROUTE = "/studio-works-2007";
const APP_STUDIO_WORKS_2008_ROUTE = "/studio-works-2008";
const APP_STUDIO_WORKS_2009_ROUTE = "/studio-works-2009";
const APP_STUDIO_WORKS_2010_ROUTE = "/studio-works-2010";
const APP_STUDIO_WORKS_2011_ROUTE = "/studio-works-2011";
const APP_STUDIO_WORKS_2012_ROUTE = "/studio-works-2012";
const APP_MANIFEST_ROUTE = "/manifest";
const APP_MOIRE_ROUTE = "/moire";
const APP_MIDI_PLAY_ROUTE = "/midi-play";
const APP_RENDER3D_ROUTE = "/render3d";
const APP_FRACTO_IMAGE_ROUTE = "/fracto";
const APP_ORBITALS_ROUTE = "/orbitals";
const APP_FREQ_ROUTE = "/freq";

export const APP_ACW_ROUTINGS = [
    APP_MAIN_ROUTE,
    APP_FRACTO_ROUTE,
    APP_MODULUS_EFFECT_ROUTE,
    APP_STUDIO_WORKS_2006_ROUTE,
    APP_STUDIO_WORKS_2007_ROUTE,
    APP_STUDIO_WORKS_2008_ROUTE,
    APP_STUDIO_WORKS_2009_ROUTE,
    APP_STUDIO_WORKS_2010_ROUTE,
    APP_STUDIO_WORKS_2011_ROUTE,
    APP_STUDIO_WORKS_2012_ROUTE,
    APP_MANIFEST_ROUTE,
    APP_MOIRE_ROUTE,
    APP_MIDI_PLAY_ROUTE,
    APP_RENDER3D_ROUTE,
    APP_FRACTO_IMAGE_ROUTE,
    APP_ORBITALS_ROUTE,
    APP_FREQ_ROUTE
];

export class AmChillWhaleApp extends Component {

    static propTypes = {
        location: PropTypes.object.isRequired
    }

    render() {
        const params = QueryString.parse(this.props.location.search);
        const segments = this.props.location.pathname.split('/').splice(2);
        const parsed = UrlParse(this.props.location.pathname, true)
        switch(parsed.pathname) {

            case APP_FRACTO_ROUTE:
                return <FractoApp {...this.props} params={params} parsed={parsed} segments={segments} />

            case APP_MODULUS_EFFECT_ROUTE:
                return <HomePage section={"the modulus effect"} extra=<ModulusEffectExtra/> />

            case APP_MAIN_ROUTE:
            case APP_STUDIO_WORKS_2006_ROUTE:
                return <HomePage section={"studio works: 2006"} />
            case APP_STUDIO_WORKS_2007_ROUTE:
                return <HomePage section={"studio works: 2007"} />
            case APP_STUDIO_WORKS_2008_ROUTE:
                return <HomePage section={"studio works: 2008"} />
            case APP_STUDIO_WORKS_2009_ROUTE:
                return <HomePage section={"studio works: 2009"} />
            case APP_STUDIO_WORKS_2010_ROUTE:
                return <HomePage section={"studio works: 2010"} />
            case APP_STUDIO_WORKS_2011_ROUTE:
                return <HomePage section={"studio works: 2011"} />
            case APP_STUDIO_WORKS_2012_ROUTE:
                return <HomePage section={"studio works: 2012"} />

            case APP_MANIFEST_ROUTE:
                return <Manifest/>

            case APP_MOIRE_ROUTE:
                return <Moire/>

            case APP_MIDI_PLAY_ROUTE:
                return <MidiPlay/>

            case APP_RENDER3D_ROUTE:
                return <Render3d/>

            case APP_FRACTO_IMAGE_ROUTE:
                return <Image/>

            case APP_ORBITALS_ROUTE:
                return <Orbitals/>

            case APP_FREQ_ROUTE:
                return <Freq params={params} segments={segments}/>

            default:
                return "bad routing"
        }
    }
}

export default AmChillWhaleApp;